import { hasLength, useForm } from '@mantine/form';
import { WrittenReviewForm } from '../types/FormTypes';
import { WrittenReviewProps } from '../types/PropsTypes';
import { RatingChangeBox } from './RatingChangeBox';
import { useCallback, useState } from 'react';
import { Button, Textarea } from '@mantine/core';
export function STUWrittenReview({
  rating,
  companyName,
  onSubmit,
  isHipaa,
}: WrittenReviewProps): JSX.Element {
  const [currentRating, setCurrentRating] = useState(rating);
  const form = useForm<WrittenReviewForm>({
    initialValues: {
      review: '',
    },
    validate: {
      review: hasLength(
        { min: 4, max: 3000 },
        'Review must be more than 4 characters long and less than 3000 characters',
      ),
    },
  });

  const hipaa_content = isHipaa ? " By providing this review, I consent to "+ companyName +" using my comments on their website and other promotional materials. I understand that my review may be de-identified to protect my privacy, and I have the right to withdraw my consent at any time by contacting "+ companyName +"." : "";
  const legalJargon = `
    By submitting your review to SoTellUs, you authorize the unrestricted use of your review by SoTellUs and by the person/entity that requested the review. 
    You hereby grant the unrestricted, irrevocable, worldwide, royalty-free right and license to copyright and use, re-use, publish, and republish photos, 
    videos, and/or audio recordings of me or in which I may be included, intact or in part, in composite or distorted in character or form, without restriction 
    as to changes, for unlimited purposes (both commercial and non-commercial), and through any and all media and methods of distribution, now known or hereafter 
    developed. All rights of privacy and publicity are hereby waived, including the right to use my name with my photos and/or videos. ${hipaa_content}
  `;

  const getDescriptor = useCallback(
    (rating: number): string => {
      if (rating < 4) {
        return "didn't love";
      } else if (rating < 5) {
        return 'like';
      } else {
        return 'LOVE';
      }
    },
    [currentRating],
  );

  return (
    <>
        <RatingChangeBox rating={currentRating} onChange={setCurrentRating} />
      <form
        className="centered-stack"
        data-clarity-unmask={true}
        onSubmit={form.onSubmit((values) => {
          if (isHipaa) {
            onSubmit(values.review, currentRating, legalJargon);
          } else {
            onSubmit(values.review, currentRating);
          }
        })}
      >
        <h4 className="header-text">
          How would you describe your experience <br/>with {companyName}?
        </h4>
        <Textarea
          styles={{
            input: { minHeight: '125px' },
          }}
          w="100%"
          placeholder={`I ${getDescriptor(currentRating)} ${companyName} because...`}
          {...form.getInputProps('review')}
          mb={10}
        />
        <Button
          type="submit"
          w={'100%'}
          color="green.7"
          size="md"
          radius={'sm'}
        >
          Submit
        </Button>
        <p className="legal-jargon">
          {legalJargon}
        </p>
      </form>
    </>
  );
}
